import { useTranslation } from 'react-i18next';
import UtmsChip from '@shared/components/ui/UtmsChip';
import { transformStringForKey } from '@shared/utils/utilsOld';

export const TestrunStatusChip = ({ status }) => {
    const { t } = useTranslation();

    if (!status) {
        return '';
    }
    return (
        <UtmsChip
            label={t(`${transformStringForKey(status)}_status`)}
            color={status.toLowerCase() === 'completed' ? 'info' : 'default'}
        />
    );
};

export default TestrunStatusChip;
